module.exports = __webpack_public_path__ + "img/qi.17baae42.png";